import { ComponentAPI } from '@philips-emr/tws-core';

class HpmsTextHtmlAPI extends ComponentAPI<any> {
  setData(data: string ): void {
    this.setState( { data } );
  }
}

export {
  HpmsTextHtmlAPI,
};
